import * as React from "react";
import { styled } from "@mui/material";
import { jsx as _jsx } from "react/jsx-runtime";
const base = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 211,
	height: 211,
	fill: "none",
	viewBox: "0 0 211 211",
	...props,
	children: /* @__PURE__ */ _jsx("circle", {
		cx: 105.5,
		cy: 105.5,
		r: 105.5,
		fill: "#FDC564"
	})
});
const SvgSun = styled(base)({});
export default SvgSun;
